import { forwardRef } from 'react';

import {
  getColor,
  getColorContrast,
  PaletteColorsCustomizable,
  SizingNames,
} from '@spazious/dollhouse-theme';
import { styled } from '@spazious/dollhouse-theme';

import { Flex, FlexElement, FlexProps } from '../Flex/index.js';

export type AvatarElement = FlexElement;

interface AvatarProps extends FlexProps {
  color?: PaletteColorsCustomizable;
  size?: SizingNames;
  children?: React.ReactNode;
}

export const Avatar: React.FC<AvatarProps> = styled(
  forwardRef<AvatarElement, AvatarProps>(({ children, ...restProps }, ref) => {
    return (
      <Flex ref={ref} {...restProps}>
        {children}
      </Flex>
    );
  })
).withConfig({
  shouldForwardProp: (prop) => !['color', 'size'].includes(prop),
  displayName: 'Avatar',
})`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  font-family: ${({ size = 'medium' }) =>
    `var(--spz-sys-typescale-label-${size}-font-family-name)`};
  font-size: ${({ size = 'medium' }) => `var(--spz-sys-typescale-label-${size}-font-size)`};
  line-height: 1;
  border-radius: 50%;
  overflow: hidden;
  user-select: none;
  background-color: ${({ color = 'primary' }) => getColor(color)};
  color: ${({ color = 'primary' }) => getColorContrast(color)};
`;
